import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LayoutComponent } from "../layout/layout.component";
import {EndorseEffectiveDateComponent} from "./endorse-effective-date.component";

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    children: [
      {
        path: 'endorse',
        component: EndorseEffectiveDateComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndorseEffectiveDateRoutingModule { }
